export default {
      id: "sortArrowDown-usage",
      viewBox: "0 0 10 5",
      url: "assets/" + "sprite.svg#sortArrowDown-usage",
      toString: function () {
        return this.url;
      }
    }